import { render, staticRenderFns } from "./AircrafNumberItem.vue?vue&type=template&id=6c228a71&scoped=true"
import script from "./AircrafNumberItem.vue?vue&type=script&lang=js"
export * from "./AircrafNumberItem.vue?vue&type=script&lang=js"
import style0 from "./AircrafNumberItem.vue?vue&type=style&index=0&id=6c228a71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c228a71",
  null
  
)

export default component.exports